import React, { useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router-dom";
import PropagateLoader from "react-spinners/PropagateLoader";
import { toast } from 'react-toastify';
import moment from "moment";
import { Modal, DatePicker, Divider } from "antd";
import BeneficiaryList from "./beneficiaryList";
import airtelLogo from '../../assets/airtel_payments_bank_logo.png';
import { POST_DMT_PAY_SPRINT_CUSTOMER_DETAIL } from "../../Utils/appConstants";
import { postRequest } from "../../Utils/AppApi";
import { DMT_OPERATOR_CONFIGS, DMT_OPERATOR } from "../moneyTransfer/dmtOperatorConfigs";

// Theme colours (matching parent)
const primaryRed = '#C9262C';
const primaryOrange = '#FF8C00';
const primaryGreen = '#02A650';
const cardBorder = '#E5E7EB';
const lightBg = '#F9FAFB';

// ✅ Same layout as AirtelImwDMT (no minWidth, maxWidth 1200px)
const DMT_PAGE_WRAPPER = {
    background: 'linear-gradient(160deg, #FFFBEB 0%, #FFF8F5 25%, #FFFBEB 50%, #F8F9FF 75%, #FFFBEB 100%)',
    padding: '20px 0',
    width: '100%',
    position: 'relative',
    overflow: 'hidden',
};

const DMT_PAGE_CONTAINER = {
    // maxWidth: '1800px',
    margin: '0 auto',
    padding: '0 15px',
    position: 'relative',
    zIndex: 2,
    width: '100%',
};

function ViewCustomer({ isCustomerInfo, findCustomerInfo }) {
    const history = useHistory();
    const location = useLocation();
    const dateFormat = "DD-MM-YYYY";
    const [customerData, setCustomerData] = useState(null);
    const [isLoading, setLoading] = useState(false);

    useEffect(() => {
        const stateCustomer = location.state?.customerData || isCustomerInfo;

        if (!stateCustomer) {
            console.error("No customer data found");
            return;
        }

        console.log("Setting customerData:", stateCustomer);
        setCustomerData(stateCustomer);
    }, [location.state, isCustomerInfo]);

    const refreshLimit = async () => {
        setLoading(true);
        if (findCustomerInfo) {
            await findCustomerInfo();
        }
        setLoading(false);
    };

    if (isLoading) {
        return (
            <div className="content text-center" style={{ margin: "250px 0" }}>
                <PropagateLoader color="#5851D2" loading={isLoading} size={25} />
            </div>
        );
    }

    if (!customerData) {
        return <div className="alert alert-warning">No customer data available. Please search again.</div>;
    }

    const customerName = customerData.senderName || customerData.customerName || "Customer";

    return (
        <section style={DMT_PAGE_WRAPPER}>
            <div style={DMT_PAGE_CONTAINER}>
                {/* Customer Header Card — identity + refresh only */}
                <div style={{
                    background: '#fff',
                    borderRadius: '20px',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                    border: `1px solid ${cardBorder}`,
                    overflow: 'hidden',
                }}>
                    <div style={{
                        background: `linear-gradient(135deg, ${primaryRed} 0%, #E8454B 100%)`,
                        padding: '18px 28px',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        gap: '10px',
                    }}>
                        <div>
                            <h3 style={{
                                margin: 0,
                                color: '#fff',
                                fontWeight: 700,
                                fontSize: '20px',
                                letterSpacing: '-0.3px',
                            }}>
                                {customerName}
                                <span style={{
                                    fontSize: '14px',
                                    fontWeight: 400,
                                    opacity: 0.8,
                                    marginLeft: '12px',
                                }}>
                                    (IMA)
                                </span>
                            </h3>
                            <div style={{
                                color: 'rgba(255,255,255,0.9)',
                                fontSize: '14px',
                                marginTop: '4px',
                            }}>
                                <i className="fas fa-mobile-alt" style={{ marginRight: '6px' }} />
                                {customerData.customerMobile}
                            </div>
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                            {/* <button
                                className="btn btn-sm"
                                onClick={refreshLimit}
                                style={{
                                    background: 'rgba(255,255,255,0.15)',
                                    border: '1.5px solid rgba(255,255,255,0.5)',
                                    color: '#fff',
                                    borderRadius: '10px',
                                    padding: '6px 16px',
                                    fontWeight: 600,
                                    fontSize: '13px',
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer',
                                    whiteSpace: 'nowrap',
                                }}
                                onMouseOver={(e) => {
                                    e.target.style.background = 'rgba(255,255,255,0.25)';
                                }}
                                onMouseOut={(e) => {
                                    e.target.style.background = 'rgba(255,255,255,0.15)';
                                }}
                            >
                                <i className="fa fa-refresh" style={{ marginRight: '6px' }} />
                                Refresh Limit
                            </button> */}
                            <img
                                src={airtelLogo}
                                alt="Airtel Logo"
                                style={{
                                    // width: '50px',
                                    height: '70px',
                                    objectFit: 'contain',
                                    // filter: 'brightness(0) invert(1)',
                                }}
                            />
                        </div>
                    </div>
                </div>

                {/* Beneficiary List Section */}
                <div style={{ marginTop: '24px' }}>
                    <ErrorBoundary>
                        <BeneficiaryList
                            customerData={customerData}
                            findCustomerInfo={findCustomerInfo}
                            config={DMT_OPERATOR_CONFIGS[DMT_OPERATOR.AIRTEL]}
                        />
                    </ErrorBoundary>
                </div>
            </div>
        </section>
    );
}

class ErrorBoundary extends React.Component {
    state = { error: null };

    static getDerivedStateFromError(error) {
        return { error };
    }

    render() {
        if (this.state.error) {
            return (
                <div style={{
                    background: '#fff',
                    borderRadius: '20px',
                    padding: '30px',
                    textAlign: 'center',
                    border: `1px solid ${cardBorder}`,
                    boxShadow: '0 4px 20px rgba(0,0,0,0.05)',
                }}>
                    <div style={{ color: '#EF4444', fontSize: '48px', marginBottom: '12px' }}>
                        <i className="fa fa-exclamation-triangle" />
                    </div>
                    <h5 style={{ color: '#1A1A2E', fontWeight: 600 }}>Oops! Something went wrong</h5>
                    <p style={{ color: '#6B7280' }}>{this.state.error.message}</p>
                    <button
                        className="btn btn-sm"
                        onClick={() => this.setState({ error: null })}
                        style={{
                            background: primaryRed,
                            color: '#fff',
                            border: 'none',
                            borderRadius: '10px',
                            padding: '8px 24px',
                            fontWeight: 600,
                            transition: 'all 0.3s ease',
                        }}
                        onMouseOver={(e) => { e.target.style.transform = 'translateY(-2px)'; e.target.style.boxShadow = '0 4px 12px rgba(201,38,44,0.3)'; }}
                        onMouseOut={(e) => { e.target.style.transform = 'translateY(0)'; e.target.style.boxShadow = 'none'; }}
                    >
                        Retry
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

export default ViewCustomer;